import React, { useState, useEffect } from 'react'
import { useSearchParams, useOutletContext } from 'react-router-dom'
import { authService } from '../../services/auth.service'
import { SplitScreenContext } from '../../layouts/SplitScreenLayout'
import TextInput from '../../components/ui/TextInput'
import HTMLReactParser from 'html-react-parser'

interface OutletContext {
  setTitle: (title: string) => void
  setMessage: (message: string) => void
}

const RequestPasswordReset = () => {
  const [searchParams] = useSearchParams()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [isSuccessful, setIsSuccessful] = useState(false)
  const { setTitle, setMessage } = useOutletContext<OutletContext>()

  useEffect(() => {
    const emailFromParams = searchParams.get('email')
    if (emailFromParams) {
      setEmail(emailFromParams)
    }
  }, [searchParams])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)

    try {
      await authService.requestPasswordReset(email)
      setIsSuccessful(true)
      setTitle('Thank you!')
      setMessage(
        "We just sent you an email with a password reset link. You'll need to click that link before you can log in."
      )
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to request password reset')
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <div className="error-message">{HTMLReactParser(error)}</div>
      {!isSuccessful && (
        <form onSubmit={handleSubmit}>
          <TextInput
            required={true}
            type="email"
            label="Email Address"
            name="email"
            value={email}
            onChange={(value: string) => setEmail(value)}
          />
          <button type="submit" className="styled-button" disabled={loading}>
            {loading ? 'Sending...' : 'Submit'}
          </button>
        </form>
      )}
    </>
  )
}

export const requestPasswordResetContext: SplitScreenContext = {
  id: 'request-password-reset',
  title: 'Reset Your Password',
  message: 'Enter your email address to receive a password reset link.',
  contentSide: 'left',
}

export default RequestPasswordReset
